// analytics.js - Utility functions for tracking events

// Analytics configuration
const ANALYTICS_ENABLED = true;
const ANALYTICS_DEBUG = false; // Set to false in production
const GA4_MEASUREMENT_ID = 'G-ZJJCYQ709N';

/**
 * Initialize analytics
 * This function initializes Google Analytics 4
 */
export const initAnalytics = () => {
    if (ANALYTICS_ENABLED) {
        if (ANALYTICS_DEBUG) {
            console.log('Analytics initialized with GA4');
        }
        // GA4 is already initialized in the HTML file
        // This function is kept for potential additional initialization
    }
};

/**
 * Track a page view
 * @param {string} pageName - The name of the page
 */
export const trackPageView = (pageName) => {
    if (ANALYTICS_ENABLED) {
        if (ANALYTICS_DEBUG) {
            console.log(`Analytics - Page View: ${pageName}`);
        }
        // Track page view with GA4
        if (typeof window !== 'undefined' && window.gtag) {
            window.gtag('config', GA4_MEASUREMENT_ID, {
                page_title: pageName,
                page_path: window.location.pathname
            });
        }
    }
};

/**
 * Track an event
 * @param {string} category - Event category (e.g., 'Button', 'Form', 'Navigation')
 * @param {string} action - Event action (e.g., 'Click', 'Submit', 'View')
 * @param {string} label - Event label (e.g., 'Hero CTA', 'Contact Form')
 * @param {object} data - Additional data to track
 */
export const trackEvent = (category, action, label, data = {}) => {
    if (ANALYTICS_ENABLED) {
        if (ANALYTICS_DEBUG) {
            console.log(`Analytics - Event: ${category} - ${action} - ${label}`, data);
        }
        // Track event with GA4
        if (typeof window !== 'undefined' && window.gtag) {
            window.gtag('event', action, {
                event_category: category,
                event_label: label,
                ...data
            });
        }
    }
};

/**
 * Track a form submission
 * @param {string} formName - The name of the form
 * @param {object} formData - The form data (sensitive data should be excluded)
 */
export const trackFormSubmission = (formName, formData = {}) => {
    // Exclude sensitive data like email, phone, etc.
    const safeData = {...formData};
    delete safeData.email;
    delete safeData.phone;
    delete safeData.password;

    trackEvent('Form', 'Submit', formName, safeData);
};

/**
 * Track a configuration change
 * @param {string} configuratorName - The name of the configurator
 * @param {object} configuration - The configuration data
 */
export const trackConfigurationChange = (configuratorName, configuration = {}) => {
    trackEvent('Configurator', 'Change', configuratorName, configuration);
};

/**
 * Track a menu interaction
 * @param {string} menuName - The name of the menu
 * @param {string} itemName - The name of the item
 * @param {string} action - The action (e.g., 'View', 'Select')
 */
export const trackMenuInteraction = (menuName, itemName, action) => {
    trackEvent('Menu', action, `${menuName} - ${itemName}`);
};
